const BASE_URL = "https://assocham.org";

export async function fetchFlagship() {
  const res = await fetch(`${BASE_URL}/api/get_flagship.php`);

  if (!res.ok) {
    throw new Error(`Flagship API failed: ${res.status}`);
  }

  const json = await res.json();

  if (!json.status) {
    throw new Error("Flagship API returned an error");
  }

  // [{ id, image, link }]
  return json.data;
}